import BackupCalculator from "../classes/backup-calculator";

if ($('.backup-calculator').length) {
    new BackupCalculator();
}
